let sessionStorage = {}
sessionStorage.setItem = (key, value) => {
  sessionStorage[key] = value
}
sessionStorage.getItem = (key) => {
  return sessionStorage[key]
}

try {
  sessionStorage = window.sessionStorage || window.localStorage || {}
} catch {
  if (console.info) {
    console.info('Unable to access sessionStorage')
  }
}

export default sessionStorage
